import React, { useState } from "react";
import AccessTable from "./AccessTable";
import CollapseItem from "../../Performance/components/CollapseItem";
import { useSelector } from "react-redux";
import Pagination from "../../../Components/Pagination/Pagination";
import { transformToPaginationMeta } from "../../../utils/pagination";

function Access({ openTarget, setOpenTarget, onPageChange, currentPage }) {
  const { categoryDetails, loading } = useSelector(state => state.performance);
  const [selectedTarget, setSelectedTarget] = useState(null);
  
  const paginationMeta = transformToPaginationMeta(categoryDetails, 10);
  const targetsData = categoryDetails?.data || [];

  return (
    <div>
      {openTarget ? (
        <CollapseItem 
          targetData={selectedTarget}
          onClose={() => {
            setOpenTarget(false);
            setSelectedTarget(null);
          }}
        />
      ) : (
        <>
          <AccessTable 
            data={targetsData} 
            setOpenTarget={setOpenTarget}
            setSelectedTarget={setSelectedTarget}
            loading={loading}
          />
          
          {/* Pagination Component */}
          {paginationMeta && (
            <Pagination
              meta={paginationMeta}
              onPageChange={onPageChange}
              loading={loading}
              className="mt-4"
            />
          )}
        </>
      )}
    </div>
  );
}

export default Access;
